export default "__VITE_ASSET__1KZK1QNL__"